<template>
  <section>
    <finances-summary />

    <finances-list
      :financial-categories="financialCategories"
    />
  </section>
</template>

<script>
import FinancesSummary from '@/components/layout/finances/summary'
import FinancesList from '@/components/layout/finances/list'
import { mapGetters } from 'vuex'

export default {
  name: 'DrFinancesDetailed',

  components: {
    FinancesSummary,
    FinancesList
  },

  props: {
    financialCategories: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    })
  }
}
</script>
